import { useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { TextLink } from "../../../components/buttons/textLink";
import { RangeRadioInput } from "../../../components/inputs/rangeRadioInput";
import { TextInput } from "../../../components/inputs/textInput";
import { HeaderSubheader } from "../../../components/typography/headerSubheader";
import { useRegisterCooperativeAccountMutation } from "../../../redux/features/auth/auth.api";
import { cooperativeSizes } from "../../../utils/constants";
import { cooperativeSignUpSchema } from "../../../validationSchema";

export const SignUpCooperative = () => {
  const [, setSearchParams] = useSearchParams();

  const [registerCooperativeAccount, { isLoading: registering }] =
    useRegisterCooperativeAccountMutation();

  const {
    values,
    errors,
    isValid,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
    setFieldValue,
  } = useFormik({
    initialValues: {
      cooperativeName: "",
      cooperativeRegNum: "",
      cooperativeEmail: "",
      password: "",
      cooperativeSize: [],
    },
    validationSchema: cooperativeSignUpSchema,
    onSubmit: async (data, { resetForm }) => {
      const payload = {
        CoopName: data.cooperativeName,
        CoopReg: data.cooperativeRegNum,
        Email: data.cooperativeEmail,
        Password: data.password,
        Size: data.cooperativeSize.join("-"),
      };

      const resp = await registerCooperativeAccount({
        ...payload,
      });

      if (resp.data?.success) {
        resetForm();
        setSearchParams({ step: "confirm-mail", email: data.cooperativeEmail });
      }
    },
  });

  return (
    <div className="w-full">
      <HeaderSubheader
        header="Cooperative Signup"
        subheader="Manage your cooperative activities in one place."
      />
      <form className="mt-6 flex flex-col gap-3" onSubmit={handleSubmit}>
        <TextInput
          type="text"
          name={"cooperativeName"}
          value={values.cooperativeName}
          placeholder="Cooperative Name"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors.cooperativeName && touched.cooperativeName
              ? errors.cooperativeName
              : ""
          }
          hasIcon={false}
        />

        <TextInput
          type="text"
          name={"cooperativeRegNum"}
          value={values.cooperativeRegNum}
          placeholder="Cooperative Registration Number"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors.cooperativeRegNum && touched.cooperativeRegNum
              ? errors.cooperativeRegNum
              : ""
          }
          hasIcon={false}
        />

        <TextInput
          type="text"
          name={"cooperativeEmail"}
          value={values.cooperativeEmail}
          placeholder="Cooperative Email Address"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors.cooperativeEmail && touched.cooperativeEmail
              ? errors.cooperativeEmail
              : ""
          }
          hasIcon={false}
        />

        <TextInput
          type="password"
          name={"password"}
          value={values.password}
          placeholder="Password"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.password && touched.password ? errors.password : ""}
          hasIcon={false}
        />

        <RangeRadioInput
          title="Select Cooperative Size"
          options={cooperativeSizes}
          setValue={(val) => {
            setFieldValue("cooperativeSize", val);
          }}
          value={values.cooperativeSize}
          errors={
            errors.cooperativeSize && touched.cooperativeSize
              ? String(errors.cooperativeSize)
              : ""
          }
        />

        <Button
          text="Create Account"
          type="submit"
          onClick={() => {}}
          disabled={!isValid || registering}
          loading={registering}
          className="w-full mt-5 md:mt-3"
        />

        <p className="w-full mt-1 !text-sm text-grey-400">
          Not a cooperative?{" "}
          <TextLink
            to="/auth/sign-up"
            text="Sign up"
            className=""
            onClick={() => {}}
          />{" "}
          as a member
        </p>
      </form>
    </div>
  );
};
